import Phaser from 'phaser';

/**
 * SplashScene - Shows a splash screen on game startup
 *
 * Displays the game logo/title with a fade-in animation,
 * then transitions to the next scene after a delay.
 */
export class SplashScene extends Phaser.Scene {
  constructor() {
    super({ key: 'SplashScene' });
  }

  create(): void {
    const { width, height } = this.cameras.main;

    // Background
    this.cameras.main.setBackgroundColor('#000000');

    // Title text (in lieu of logo image for now)
    const title = this.add.text(width / 2, height / 2, 'SPILLESAMMEN', {
      fontSize: '48px',
      color: '#ffffff',
      fontStyle: 'bold',
    });
    title.setOrigin(0.5);
    title.setAlpha(0);

    // Subtitle
    const subtitle = this.add.text(width / 2, height / 2 + 60, 'Play Together', {
      fontSize: '24px',
      color: '#888888',
    });
    subtitle.setOrigin(0.5);
    subtitle.setAlpha(0);

    // Fade in animation
    this.tweens.add({
      targets: [title, subtitle],
      alpha: 1,
      duration: 1000,
      ease: 'Power2',
      onComplete: () => {
        // Wait 2 seconds then transition
        this.time.delayedCall(2000, () => {
          this.transitionToNext();
        });
      },
    });
  }

  /**
   * Transition to the next scene
   */
  private transitionToNext(): void {
    // Check if PreloaderScene exists, otherwise go to first game scene
    const nextScene = this.scene.get('PreloaderScene')
      ? 'PreloaderScene'
      : this.registry.get('firstGameScene') || 'GameScene';

    this.scene.start(nextScene);
  }
}
